import { HttpOptions } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

/* Lokal */
// const baseURL = "https://woodbook.ddev.site/api";
/* Basis-URL der API ohne /api (für Download-Links) */
// export const apiBaseUrl = "https://woodbook.ddev.site/";
/* DEV */
const baseURL= "https://api-dev.woodbook.info/api";
/* Woodbook */
//const baseURL= "https://api.woodbook.info/api";

const baseHttpOptions = async (url: string) => {
    const { value } = await Preferences.get({ key: 'token' })

    let options: HttpOptions = {
        url: `${baseURL}/${url}`,
        headers: {
            'Content-Type': 'application/json',
        },
    };


    if (value) {
        options.headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${value}`
        }
    }

    return options;
}

export default baseHttpOptions;